<div class="container">
  <div class="inner">
    <sui-icon name="차단"></sui-icon>
    <span>기간 만료</span>
  </div>
  <button (click)="onDeleteButtonClick()">삭제</button>
</div>
